
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/other-user/inventory/planet/detail",
      function () {
        return require("private-next-pages/other-user/inventory/planet/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/other-user/inventory/planet/detail"])
      });
    }
  